import { Popover } from '@all-manager/design-system-v2';
import ViewEventModal from '../../../../components/modals/ViewEventModal';
import { CalendarItemDatabase } from '../../../../types';
import ReminderDetail from '../../../reminders/external-components/ReminderDetail/ReminderDetail';

type Props = {
  item: CalendarItemDatabase;
  anchor: HTMLElement | null;
  onClose: () => void;
};

/** Detail of the calendar item the user activated: the event sheet or the reminder card. */
export default function CalendarItemDetail(props: Props) {
  if (!props.item.id) {
    return null;
  }

  if (props.item.type === 'event') {
    return (
      <ViewEventModal
        eventId={props.item.id}
        anchorEl={props.anchor}
        onClose={props.onClose}
      />
    );
  }

  if (props.item.type === 'reminder') {
    return (
      <Popover
        open
        anchorEl={props.anchor}
        onClose={props.onClose}
        aria-label={props.item.title ?? 'Rappel'}
      >
        <ReminderDetail id={props.item.id} />
      </Popover>
    );
  }

  return null;
}
